module.exports = __webpack_public_path__ + "static/media/EventOnboarding.cdbd9f2d.png";